import React from 'react'
import moment from "moment";
import style from '../admin/exam/ExamResult.module.css';
import axios from "axios";
import { baseUrl } from "../../baseUrl";
import { useParams } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

const TWPSolution = () => {
  const [exam, setExam] = useState(null);
  const [TPTSolution, setTPTSolution] = useState([]);
  const { examId } = useParams();
  const [generating, setGenerating] = useState(false)
  const contentRef = useRef()

  const generatePdf = async () => {
    setGenerating(true);
    try {
      const response = await axios.post(
        `${baseUrl}/custom-exam/generate-pdf`,
        {
          htmlContent: contentRef.current
            ? contentRef.current.innerHTML
            : '',
          fileName: `${exam.examName}-Question Paper.pdf`,
        },
        {
          responseType: 'arraybuffer',
        }
      );

      const blob = new Blob([response.data], { type: 'application/pdf' });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `${exam.examName}-Solution.pdf`;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      setGenerating(false);
    } catch (error) {
      console.error('Error generating PDF:', error);
      setGenerating(false);
    }
  };

  const getQuestionNumber = (subject, index, examType) => {
    if (examType === 'topic-wise') {
      return index + 1;
    }
    const sectionRanges = {
      "Physics": { start: 1, end: 45 },
      "Chemistry": { start: 46, end: 90 },
      "Biology": { start: 91, end: 180 },
    };

    const sectionKey = subject;
    const sectionRange = sectionRanges[sectionKey];

    if (sectionRange) {
      return sectionRange.start + index;
    }

    return index + 1; // Fallback
  };

  const filterAndMapQuestions = (subject) => {
    const filteredQuestions = TPTSolution?.filter(q => q.subject === subject);
    return filteredQuestions;
  };

  const getExamDetails = async () => {
    try {
      const response = await axios.get(`${baseUrl}/dynamic-exam/get`, {
        params: { examId: examId },
      });
      setExam(response.data);
      setTPTSolution(response.data.questions);
    } catch (error) {
      console.error('Error fetching exam details:', error);
    }
  }

  useEffect(() => {
    getExamDetails();
  }, [examId]);


  const allQuestions = exam?.type === 'topic-wise' ? TPTSolution : [];
  if (exam?.type !== 'topic-wise') {
    // For NEET Flexi, collect all questions with their correct numbering
    const sectionRanges = {
      "Physics": { start: 1, end: 45 },
      "Chemistry": { start: 46, end: 90 },
      "Biology": { start: 91, end: 180 },
    };
    for (const subject in sectionRanges) {
      const questions = filterAndMapQuestions(subject);
      const range = sectionRanges[subject];

      if (questions && questions.length) {
        questions.forEach((answer, index) => {
          allQuestions.push({
            number: range.start + index,
            answer: answer.correct,
            question: answer,
          });
        });
      }
    }
  }

  const chunked = [];
  for (let i = 0; i < allQuestions.length; i += 20) {
    chunked.push(allQuestions.slice(i, i + 20));
  }

  return (
            <>
            <div className="d-flex justify-content-center">
                <button
                    className="btn btn-success btn-sm my-2"
                    disabled={generating}
                    onClick={generatePdf}
                >
                    {generating ? (
                        <>
                            Downloading...
                            <img
                                src="/assets/images/waiting.gif"
                                width="25px"
                                alt="loading"
                            />
                        </>
                    ) : (
                        'Download PDF'
                    )}
                </button>
            </div>
    <div className='container my-4'>
      <div ref={contentRef}>
      <div className='row' style={{ border: '1px solid black', display: 'flex', alignItems: 'center' }}>
        <div className='col-4 d-flex justify-content-center'>
          <img src='/assets/images/monoarclogo2.jpeg' width='95%' alt='logo' className='my-3' />
        </div>
        <div
          className='col-5 d-flex flex-column justify-content-center text-center'
          style={{ borderRight: '1px solid black', borderLeft: '1px solid black', alignSelf: 'stretch', }}
        >
          <h3 className='fw-bold'>{exam?.type==="topic-wise" ? "Topic Wise Practice" : "NEET Flexi Test"}</h3>
        </div>
        <div className='col-3 d-flex flex-column justify-content-center fw-bold'>
          <span>NEET UG</span>
          <span>{exam?.className}</span>
          <span>Date : {moment(exam?.startDate).format('DD MMMM YYYY')}</span>
        </div>
      </div>
      <div className='row'>
        <h4 className="text-center py-1 fw-bold" style={{ borderBottom: '1px solid black' }}>{exam?.examName}</h4>
        <h4 className="text-center fw-bold">Answer Key</h4>
      </div>
      <div className='row'>
        <table
          style={{
            borderCollapse: 'collapse',
            tableLayout: 'auto',
            borderSpacing: 0
          }}
        >
          <tbody>
            {chunked.map((chunk, idx) => (
              <React.Fragment key={idx}>
                <tr>
                  <td className='aq-key' style={{ backgroundColor: '#f0f0f0', border: '1px solid black', fontWeight: 'bold', padding: '4px', whiteSpace: 'nowrap', textAlign: 'center', verticalAlign: 'middle' }}>
                    Q.
                  </td>
                  {chunk.map((q, i) => (
                    <td
                      key={`q-${q.number || (i + 1)}`}
                      className='aq-key'
                      style={{ backgroundColor: '#f0f0f0', border: '1px solid black', padding: '4px', whiteSpace: 'nowrap', textAlign: 'center', verticalAlign: 'middle' }}
                    >
                      {exam?.type === 'topic-wise' ? getQuestionNumber(q.subject, i + idx * 20, exam?.type) : q.number}
                    </td>
                  ))}
                </tr>
                <tr>
                  <td style={{ border: '1px solid black', fontWeight: 'bold', padding: '4px', whiteSpace: 'nowrap', textAlign: 'center', verticalAlign: 'middle' }}>
                    A.
                  </td>
                  {chunk.map((q, i) => (
                    <td
                      key={`a-${q.number || (i + 1)}`}
                      style={{ border: '1px solid black', padding: '4px', whiteSpace: 'nowrap', textAlign: 'center', verticalAlign: 'middle' }}
                    >
                      {exam?.type === 'topic-wise' ? (isNaN(q.correct) ? (q.options.indexOf(q.correct) + 1) : q.correct) : (isNaN(q.answer) ? (q.question.options.indexOf(q.answer) + 1) : q.answer)}
                    </td>
                  ))}
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
        <h4 className='text-center fw-bold' style={{ borderBottom: '1px solid black' }}>Solutions</h4>
      </div>
      <div className='row' style={{ borderRight: '1px solid black', borderLeft: '1px solid black', borderBottom: '1px solid black' }}>
        {exam?.type === 'topic-wise' ? (
          // For topic-wise exams, show all solutions in one section
          TPTSolution.map((q, i) => (
            <div key={i} className={`px-1 question ${style.questionPaper}`}>
              <div className="d-flex"
                dangerouslySetInnerHTML={{
                  __html: `<span class='mr-2 fw-bold fs-6'>${getQuestionNumber(q.subject, i, exam?.type)}.</span>&nbsp;&nbsp;<span>
                                  <b>Ans ( ${q.correct} )</b><br>${q.solution}</span>`,
                }}
              >
              </div>
            </div>
          ))
        ) : (
          // For NEET Flexi exams, show solutions by subject sections
          <>
            {filterAndMapQuestions("Physics") && filterAndMapQuestions("Physics").length > 0 && (
              <div className='px-0'>
                <h5 className="text-center fw-bold" style={{ borderBottom: '1px solid black' }}>Physics</h5>
                {filterAndMapQuestions("Physics").map((q, i) => (
                  <div key={i} className={`px-1 question ${style.questionPaper}`}>
                    <div className="d-flex"
                      dangerouslySetInnerHTML={{
                        __html: `<span class='mr-2 fw-bold fs-6'>${getQuestionNumber(q.subject, i, exam?.type)}.</span>&nbsp;&nbsp;<span>
                                        <b>Ans ( ${q.correct} )</b><br>${q.solution}</span>`,
                      }}
                    >
                    </div>
                  </div>
                ))}
              </div>
            )}
            {filterAndMapQuestions("Chemistry") && filterAndMapQuestions("Chemistry").length > 0 && (
              <div className='px-0'>
                <h5 className="text-center fw-bold" style={{ borderTop: '1px solid black', borderBottom: '1px solid black' }}>Chemistry</h5>
                {filterAndMapQuestions("Chemistry").map((q, i) => (
                  <div key={i} className={`px-1 question ${style.questionPaper}`}>
                    <div className="d-flex"
                      dangerouslySetInnerHTML={{
                        __html: `<span class='mr-2 fw-bold fs-6'>${getQuestionNumber(q.subject, i, exam?.type)}.</span>&nbsp;&nbsp;<span>
                                        <b>Ans ( ${q.correct} )</b><br>${q.solution}</span>`,
                      }}
                    >
                    </div>
                  </div>
                ))}
              </div>
            )}
            {filterAndMapQuestions("Biology") && filterAndMapQuestions("Biology").length > 0 && (
              <div className='px-0'>
                <h5 className="text-center fw-bold" style={{ borderTop: '1px solid black',borderBottom: '1px solid black' }}>Biology</h5>
                {filterAndMapQuestions("Biology").map((q, i) => (
                  <div key={i} className={`px-1 question ${style.questionPaper}`}>
                    <div className="d-flex"
                      dangerouslySetInnerHTML={{
                        __html: `<span class='mr-2 fw-bold fs-6'>${getQuestionNumber(q.subject, i, exam?.type)}.</span>&nbsp;&nbsp;<span>
                                        <b>Ans ( ${q.correct} )</b><br>${q.solution}</span>`,
                      }}
                    >
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
      </div>
    </div>
    </>
  )
}

export default TWPSolution
